import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { leadsApi } from "../../../libs/landvoice-api";
import { Listing } from "../../../types/listing";
import { GetLeadsOptions } from "../../../types/neighborhoodSearch";
import { getListingFromLead } from "../../../utils/neighborhoodSearch";
import { generateSearchListingsQueryKey } from "../utils/generateSearchListingsQueryKey";
import {
  BEDS_MIN,
  BEDS_MAX,
  BATHS_MIN,
  BATHS_MAX,
  ACREAGE_MIN,
  ACREAGE_MAX,
  SQFT_MIN,
  SQFT_MAX,
  YEAR_BUILT_MIN,
} from "src/constants/neighborhoodSearch";
import { getMinMaxQueryParams } from "../utils/getMinMaxQueryParams";
import { getYearBuiltMax } from "../../../utils/neighborhoodSearch";

export const usePagedNsSearchListingsQuery = ({
  bedrooms,
  bathrooms,
  acreage,
  squareFootage,
  yearBuilt,
  propertyType,
  tag = "",
  note = "",
  favorite = undefined,
  companyOwned = undefined,
  showHidden = undefined,
  onlyHidden = undefined,
  listId = [],
  currentPage = 1,
  pageSize = 25,
}: GetLeadsOptions): UseQueryResult<{
  listings: Listing[];
  total_records: number;
}> => {
  return useQuery({
    queryKey: generateSearchListingsQueryKey({
      bedrooms,
      bathrooms,
      acreage,
      squareFootage,
      yearBuilt,
      propertyType,
      favorite,
      tag,
      note,
      companyOwned,
      showHidden,
      onlyHidden,
      listId,
      currentPage,
      pageSize,
    }),
    queryFn: async () => {
      const offset = (currentPage - 1) * pageSize;
      const { data } = await leadsApi.getLeadsWithCount(
        getMinMaxQueryParams(
          Number(bedrooms?.[0]),
          Number(bedrooms?.[1]),
          BEDS_MIN,
          BEDS_MAX
        ),
        getMinMaxQueryParams(
          Number(bathrooms?.[0]),
          Number(bathrooms?.[1]),
          BATHS_MIN,
          BATHS_MAX
        ),
        getMinMaxQueryParams(
          Number(acreage?.[0]),
          Number(acreage?.[1]),
          ACREAGE_MIN,
          ACREAGE_MAX
        ),
        getMinMaxQueryParams(
          Number(squareFootage?.[0]),
          Number(squareFootage?.[1]),
          SQFT_MIN,
          SQFT_MAX
        ),
        getMinMaxQueryParams(
          Number(yearBuilt?.[0]),
          Number(yearBuilt?.[1]),
          YEAR_BUILT_MIN,
          getYearBuiltMax()
        ),
        propertyType,
        favorite,
        tag,
        note,
        companyOwned,
        showHidden,
        onlyHidden,
        listId,
        offset,
        pageSize
      );
      return {
        listings: (data.leads || []).map((lead) => getListingFromLead(lead)),
        total_records: data.total_count,
      };
    },
    enabled: !!(currentPage && pageSize && listId?.length),
  });
};